import React from "react";
import { useSelector } from "react-redux";
import { navigate } from "@reach/router";
import { RootState } from "@/redux/reducers";
import IconShield from "@/assets/icons/shield.svg";
import "./styles.less";

const Unauthorized = () => {
  const error: any = useSelector(
    (state: RootState) => state.errors.FETCH_ENTITY
  );

  const goToLogin = () => {
    navigate("/auth/login");
  };

  return (
    <div className="Unauthorized">
      <div className="Unauthorized-image">
        <img src={IconShield} alt="Open Banking" />
      </div>
      <h1 className="Unauthorized-title">We Are Sorry</h1>
      <p className="Unauthorized-description">
        {error?.message || (
          <>
            It seems like you do not have permission to access this site
            <br />
            Please contact support
          </>
        )}
      </p>
      <div className="Unauthorized-login">
        If you are a member,{" "}
        <span
          onClick={goToLogin}
          role="button"
          tabIndex={0}
          className="Unauthorized-login-link"
          onKeyDown={(e) => {
            if (e.key === "Enter" || e.key === " ") {
              goToLogin();
            }
          }}
        >
          click here to login
        </span>
      </div>
    </div>
  );
};

export default Unauthorized;
